/**
 * Milliseconds the toast takes to settle into a new shape.
 */
export const SPRING_DURATION_MS = 600;

/**
 * Gives a single ~4% overshoot, which reads as deliberate rather than bouncy.
 */
const DAMPING_RATIO = 0.72;

/**
 * 9.2 is the decay exponent reached by the end, so the spring has settled
 * rather than being cut mid-bounce.
 */
const FREQUENCY = 9.2 / (DAMPING_RATIO * (SPRING_DURATION_MS / 1000));

const DAMPED_FREQUENCY = FREQUENCY * Math.sqrt(1 - DAMPING_RATIO ** 2);

/**
 * A damped spring from 0 to 1 by progress; returns slightly more than 1 at the
 * overshoot, so sizes must clamp.
 */
export function springEase(progress: number): number {
  if (progress <= 0) return 0;
  if (progress >= 1) return 1;

  const seconds = progress * (SPRING_DURATION_MS / 1000);
  const decay = Math.exp(-DAMPING_RATIO * FREQUENCY * seconds);
  const phase =
    Math.cos(DAMPED_FREQUENCY * seconds) +
    ((DAMPING_RATIO * FREQUENCY) / DAMPED_FREQUENCY) * Math.sin(DAMPED_FREQUENCY * seconds);

  return 1 - decay * phase;
}
